<template>
  <section class="services">
    <div class="container price-card">
      <div class="row fade-in">
        <div class="col-12">
          <h1 class="text-center">Preisliste</h1>
        </div>
      </div>
      <div class="price-list">
        <div class="row">
          <div class="col-12 col-lg-6 fade-in">
            <!--Products-->
            <h3>It's Your Time</h3>
            <div class="row product">
              <div class="col-12">
                <div class="head">
                  <span class="product-title">Just Clean</span>
                  <span class="price">50€</span>
                </div>
              </div>
              <div class="col-12 col-lg-10">
                <p>Reinigung, Peeling, Vapozon, Entfernen von Hautunreinheiten, Maske,
                  Abschlusspflege<br/> ca. 45 Minuten</p>
              </div>
            </div>
            <div class="row product">
              <div class="col-12">
                <div class="head">
                  <span class="product-title">Special Beauty</span>
                  <span class="price">59€</span>
                </div>
              </div>
              <div class="col-12 col-lg-10">
                <p>Reinigung, Peeling, Vapozon, Entfernen von Hautunreinheiten, Maske, Massage,
                  Abschlusspflege<br/> ca. 75 Minuten</p>
              </div>
            </div>
            <div class="row product">
              <div class="col-12">
                <div class="head">
                  <span class="product-title">Anti Aging</span>
                  <span class="price">66€</span>
                </div>
              </div>
              <div class="col-12 col-lg-10">
                <p>Reinigung, Peeling, Vapozon, Entfernen von Hautunreinheiten, Wirkstoff
                  Ampulle, Maske, Massage, Abschlusspflege<br/> ca. 90 Minuten</p>
              </div>
            </div>
            <div class="row product">
              <div class="col-12">
                <div class="head">
                  <span class="product-title">Top Anti Aging</span>
                  <span class="price">80€</span>
                </div>
              </div>
              <div class="col-12 col-lg-10">
                <p>Anti Aging Behandlung + intensiver Augenpflege, Hals & Dekolleté
                  Behandlung</p>
              </div>
            </div>
            <div class="row product">
              <div class="col-12">
                <div class="head">
                  <span class="product-title">Microneedling Gesicht</span>
                  <span class="price">105€</span>
                </div>
              </div>
              <div class="col-12 col-lg-10">
                <p>Kleine Nadeln, große Wirkung!<br/>
                  Für eine glattere, feinere und straffere Haut. <br/>
                  Reinigung, Wirkstoff Ampulle, Needling, beruhigende Abschlusspflege
                </p>
              </div>
            </div>
            <div class="row product">
              <div class="col-12">
                <div class="head">
                  <span class="product-title">Microneedling Gesicht und Dekolleté</span>
                  <span class="price">150€</span>
                </div>
              </div>
            </div>
            <div class="row product">
              <div class="col-12">
                <div class="head">
                  <span class="product-title">Special Clean</span>
                  <span class="price">12€</span>
                </div>
              </div>
              <div class="col-12 col-lg-10">
                <p>Intensives Frimator Bürstenpeeling, Gesicht, Hals und Dekolleté, Ergänzung zu
                  jeder Behandlung </p>
              </div>
            </div>
            <div class="row product">
              <div class="col-12">
                <div class="head">
                  <span class="product-title">Hals & Dekolleté Behandlung</span>
                  <span class="price">20€</span>
                </div>
              </div>
              <div class="col-12 col-lg-10">
                <p>Reinigung, Peeling, Ampulle, Massage</p>
              </div>
            </div>
            <div class="row rosa-graf-section fade-in">
              <div class="col-12">
                <div>
                  <h3 style="font-size:17px;">Auf Wunsch:</h3>
                  <div>Nach jeder Behandlung ein kleines Tages Make Up</div>
                </div>
              </div>
              <div class="col-6 offset-3">
                <div class="logo">
                  <img src="../../../assets/images/rg_logo.svg" alt="Svg Logo von Rosa Graf">
                </div>
              </div>
            </div>
            <!-- Products end -->
          </div>
          <div class="col-12 col-lg-6 fade-in">
            <div class="row product">
              <div class="col-12">
                <div class="head">
                  <span class="product-title">Anti Aging Augenbehandlung</span>
                  <span class="price">12€</span>
                </div>
              </div>
              <div class="col-12 col-lg-10">
                <p>Augenpads inkl. Anti Aging Wirkstoff</p>
              </div>
            </div>
            <div class="row product">
              <div class="col-12">
                <div class="head">
                  <span class="product-title">Rückenbehandlung</span>
                  <span class="price">30€</span>
                </div>
              </div>
              <div class="col-12 col-lg-10">
                <p>Reinigung, Peeling, Entfernen von Hautunreinheiten, Beruhigungsmaske, ca. 30
                  Minuten</p>
              </div>
            </div>
            <h3>waxing</h3>
            <div class="row product">
              <div class="col-12">
                <div class="head">
                  <span class="product-title">Oberlippenbehaarung</span>
                  <span class="price">ab 15€</span>
                </div>
              </div>
            </div>
            <div class="row product">
              <div class="col-12">
                <div class="head">
                  <span class="product-title">Achselbereich</span>
                  <span class="price">ab 20€</span>
                </div>
              </div>
            </div>
            <div class="row product">
              <div class="col-12">
                <div class="head">
                  <span class="product-title">Beine, bis Knie</span>
                  <span class="price">ab 30€</span>
                </div>
              </div>
            </div>
            <div class="row product">
              <div class="col-12">
                <div class="head">
                  <span class="product-title">Beine, komplett</span>
                  <span class="price">ab 40€</span>
                </div>
              </div>
            </div>
            <h3>Eye-Treatment</h3>
            <div class="row product">
              <div class="col-12">
                <div class="head">
                  <span class="product-title">Lash Lifting</span>
                  <span class="price">ab 50€</span>
                </div>
              </div>
            </div>
            <div class="row product">
              <div class="col-12">
                <div class="head">
                  <span class="product-title">Färben - Wimpern</span>
                  <span class="price">ab 13€</span>
                </div>
              </div>
            </div>
            <div class="row product">
              <div class="col-12">
                <div class="head">
                  <span class="product-title">Färben - Augenbrauen</span>
                  <span class="price">ab 12€</span>
                </div>
              </div>
            </div>
            <div class="row product">
              <div class="col-12">
                <div class="head">
                  <span class="product-title">Augenbrauen Korrektur - Zupfen</span>
                  <span class="price">ab 12€</span>
                </div>
              </div>
            </div>
            <h3>Maniküre & Pedikküre</h3>
            <div class="row product">
              <div class="col-12">
                <div class="head">
                  <span class="product-title">Pediküre</span>
                  <span class="price">ab 32€</span>
                </div>
              </div>
              <div class="col-12 col-lg-10">
                <p>Fusspflege, nach medizinischen Richtlinien, ca. 30 Minuten</p>
              </div>
            </div>
            <div class="row product">
              <div class="col-12">
                <div class="head">
                  <span class="product-title">Wellness Fußbad</span>
                  <span class="price">ab 5€</span>
                </div>
              </div>
            </div>
            <div class="row product">
              <div class="col-12">
                <div class="head">
                  <span class="product-title">Pediküre</span>
                  <span class="price">ab 48€</span>
                </div>
              </div>
              <div class="col-12 col-lg-10">
                <p>mit Wellness Massage</p>
              </div>
            </div>
            <div class="row product">
              <div class="col-12">
                <div class="head">
                  <span class="product-title">Maniküre</span>
                  <span class="price">ab 30€</span>
                </div>
              </div>
              <div class="col-12 col-lg-10">
                <p>Handpflege, ca. 30 Minuten </p>
              </div>
            </div>
            <div class="row product">
              <div class="col-12">
                <div class="head">
                  <span class="product-title">Lackieren</span>
                  <span class="price">ab 8€</span>
                </div>
              </div>
              <div class="col-12 col-lg-10">
                <p>Zusatz zur Pediküre und Maniküre</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Products end -->
  </section>
</template>

<script>
export default {
  name: "Services"
}
</script>

<style scoped lang="scss">
@import 'src/assets/scss/imports';

h1, h3 {
  text-transform: uppercase;
  letter-spacing: 4px;
}

h3 {
  margin-top: 25px;
}

.price-card {
  .price-list {
    margin-top: 25px;

    p {
      max-width: 90%;
    }

    .eyebrow {
      margin: 10px 0 10px 0;
    }

    .head {
      display: flex;
      margin-top: 20px;
    }

    .product-title {
      max-width: 83%;
      font-size: 20px;
    }

    .price {
      position: absolute;
      left: 80%;
      font-size: 20px
    }

    .logo > img {
      margin-top: 35px;
    }
  }
}
</style>
